import React from "react";
import "./index.css";

const NotificationSkeleton = () => {
  return (
    <div className='notification-skeleton-container'>
      {/* Header */}
      <div className='notification-skeleton-header'>
        <div className='notification-skeleton-title'></div>
        <div className='notification-skeleton-close-btn'></div>
      </div>

      {/* Notification Items */}
      <div className='notification-skeleton-list'>
        {/* Notification 1 */}
        <div className='notification-skeleton-item'>
          <div className='notification-skeleton-avatar'></div>
          <div className='notification-skeleton-content'>
            <div className='notification-skeleton-text-primary'></div>
            <div className='notification-skeleton-text-secondary'></div>
            <div className='notification-skeleton-timestamp'></div>
          </div>
        </div>

        {/* Notification 2 */}
        <div className='notification-skeleton-item'>
          <div className='notification-skeleton-avatar'></div>
          <div className='notification-skeleton-content'>
            <div className='notification-skeleton-text-primary'></div>
            <div className='notification-skeleton-text-secondary'></div>
            <div className='notification-skeleton-timestamp'></div>
          </div>
        </div>

        {/* Notification 3 */}
        <div className='notification-skeleton-item'>
          <div className='notification-skeleton-avatar'></div>
          <div className='notification-skeleton-content'>
            <div className='notification-skeleton-text-primary'></div>
            <div className='notification-skeleton-text-secondary'></div>
            <div className='notification-skeleton-timestamp'></div>
          </div>
        </div>

        {/* Notification 4 */}
        <div className='notification-skeleton-item'>
          <div className='notification-skeleton-avatar'></div>
          <div className='notification-skeleton-content'>
            <div className='notification-skeleton-text-primary'></div>
            <div className='notification-skeleton-text-secondary'></div>
            <div className='notification-skeleton-timestamp'></div>
          </div>
        </div>

        {/* Notification 5 */}
        <div className='notification-skeleton-item'>
          <div className='notification-skeleton-avatar'></div>
          <div className='notification-skeleton-content'>
            <div className='notification-skeleton-text-primary'></div>
            <div className='notification-skeleton-text-secondary'></div>
            <div className='notification-skeleton-timestamp'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSkeleton;
